import { Box, Button, Grid, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import InputMascarado from "../../../../shared/components/formulario/input-mascarado/InputMascarado";
import { mascaraCnpj, mascaraCpf, mascaraTelefone } from "../../../../shared/utils/mascaras";
import { EnderecoFormPart } from "../../../../shared/components/formulario/parts/EnderecoFormPart/enderecoform.part";

export function TabDadosDaEmpresa(
    { empresaRaw, control, errors, methods, setTab, mdDown }: any
) {
    return (
        <Box>
            <Grid container spacing={2}>
                {/* Campos editáveis */}
                {empresaRaw.fullName !== null && (
                    <Grid item xs={12} md={6}>
                        <Controller
                            name="fullName"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    label="Nome Completo"
                                    error={!!errors.fullName}
                                    helperText={errors.fullName?.message}
                                    fullWidth
                                    size="small"
                                />
                            )}
                        />
                    </Grid>
                )}
                <Grid item xs={12} md={6}>
                    <Controller
                        name="fantasyName"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Nome Fantasia"
                                error={!!errors.fantasyName}
                                helperText={errors.fantasyName?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Controller
                        name="email"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="E-mail"
                                error={!!errors.email}
                                helperText={errors.email?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Controller
                        name="phone"
                        control={control}
                        render={({ field }) => (
                            <InputMascarado
                                name="phone"
                                methods={methods}
                                value={empresaRaw.phone}
                                label="Digite o Telefone"
                                mask={mascaraTelefone}
                            />
                        )}
                    />
                </Grid>

                {/* Campos somente leitura (exceto id, criado em e atualizado em) */}
                {empresaRaw.cnpj !== null && (
                    <Grid item xs={12} md={6}>
                        <InputMascarado
                            name="cnpj"
                            methods={methods}
                            value={empresaRaw.cnpj}
                            label="CNPJ"
                            mask={mascaraCnpj}
                            disabled
                        />
                    </Grid>
                )}
                {empresaRaw.corporateName !== null && (
                    <Grid item xs={12} md={6}>
                        <TextField
                            label="Razão Social"
                            value={empresaRaw.corporateName}
                            fullWidth
                            size="small"
                            disabled
                        />
                    </Grid>
                )}
                {empresaRaw.cpf !== null && (
                    <Grid item xs={12} md={6}>
                        <InputMascarado
                            name="cpf"
                            methods={methods}
                            value={empresaRaw.cpf}
                            label="CPF"
                            mask={mascaraCpf}
                        />
                    </Grid>
                )}
                {empresaRaw.active !== null && empresaRaw.active !== undefined && (
                    <Grid item xs={12} md={6}>
                        <TextField
                            label="Ativo"
                            value={empresaRaw.active ? "Sim" : "Não"}
                            fullWidth
                            size="small"
                            disabled
                        />
                    </Grid>
                )}
            </Grid>
            <EnderecoFormPart methods={methods} mdDown={mdDown} />
            <Box mt={2} display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={() => setTab(1)}>
                    Próximo: Configuração
                </Button>
            </Box>
        </Box>
    )
}